<script lang="ts">
import { defineComponent, PropType, inject, watch } from 'vue'
import SelectorForm from '@/components/form/SelectorForm.vue'

export default defineComponent({
  name: 'SelectorListingStatus',

  components: {
    SelectorForm,
  },

  props: {
    listingStatus: {
      type: Object as PropType<InputText>,
      required: true,
    },

    namespace: {
      type: String,
      default: '',
    },

    defaultSelectorLabel: {
      type: String,
      default: '選択してください',
    },

    defaultSelectorValue: {
      type: String,
      default: '',
    },

    header: {
      type: String,
      default: '上場区分',
    },
  },

  emits: [
    'update:listingStatus',
  ],

  setup(props, { emit }) {
    const LISTING_STATUSES = inject<string[]>('LISTING_STATUSES')!

    // 選択肢に存在しない値の場合は空の値で再設定
    // ※ 古いユーザの場合、古い区分で値を保持している場合があり、その場合は強制的に再設定させる。
    watch(() => props.listingStatus.value, () => {
      if (props.listingStatus.value && !LISTING_STATUSES.includes(props.listingStatus.value)) {
        emit('update:listingStatus', '')
      }
    })

    const emitValue = (value: string) => {
      if (typeof value === 'string') {
        emit('update:listingStatus', value)
      } else {
        emit('update:listingStatus', '')
      }
    }

    return {
      // constants
      LISTING_STATUSES,

      // methods
      emitValue,
    }
  }
})
</script>

<template>
  <SelectorForm
    :model-value="listingStatus.value"
    :items="LISTING_STATUSES"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :namespace="namespace"
    :name="listingStatus.name"
    :header="header"
    :validation-scheme="listingStatus.validationScheme"
    @update:model-value="emitValue($event)" />
</template>
